import { no } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Velkommen",
    login: "Logg inn",
    logout: "Logg ut",
    about: "Om",
    dashboard: "Forside",
    products: "Produkter",
    users: "Brukere",
    labels: "Etiketter",
    createUser: "Opprett bruker",
    editUser: "Rediger bruker",
    deleteUser: "Slett bruker",
    userList: "Brukerliste",
    productList: "Produktliste",
    createProduct: "Opprett produkt",
    editProduct: "Rediger produkt",
    deleteProduct: "Slett produkt",
    labelSettings: "Etikettinnstillinger",
    createCategory: "Opprett kategori",
    editCategory: "Rediger kategori",
    deleteCategory: "Slett kategori",
    categoryList: "Kategoriliste",
    dragToReorder: "Dra for å endre rekkefølgen på kategoriene",
    name: "Navn",
    nameFormat: "Navn (Fornavn Etternavn)*",
    email: "E-post",
    emailFormat: "E-post*",
    role: "Er administrator",
    actions: "Handlinger",
    save: "Lagre",
    cancel: "Avbryt",
    edit: "Rediger",
    delete: "Slett",
    confirmDelete: "Er du sikker på at du vil slette dette elementet?",
    yes: "Ja",
    no: "Nei",
    search: "Søk...",
    itemsPerPageText: "Elementer per side:",
    pageText: "{0}-{1} av {2}",
    productName: "Produktnavn*",
    productNumber: "Produktnummer",
    productOnList: "Produktnavn",
    category: "Kategori",
    categoryOnList: "Kategori",
    categories: "Kategorier",
    noCategories: "Ingen kategorier",
    thawingDays: "Tining (dager)",
    notesHint: "Ytterligere informasjon om dette produktet",
    refridgeDays: "Kjøleskap (dager)",
    threeHoursHint: "Kan produktet stå ute i 3 timer?",
    allergens: "Allergener",
    selectAllergens: "Velg allergener",
    noAllergens: "Ingen allergener",
    notes: "Notat",
    daysUntilExpiration: "Dager til utløp",
    daysNeededForThawing: "Dager som trengs for tining",
    daysInRefrigeration: "Dager i kjøleskap",
    producedDateLabel: "Produksjonsdato",
    openedDateLabel: "Åpnet dato",
    createdAt: "Opprettet den",
    updatedAt: "Oppdatert den",
    expirationDate: "Utløpsdato",
    openedDate: "Åpnet dato",
    producedDate: "Produksjonsdato",     
    numLabels: "Antall etiketter",
    quantity: "Antall",
    foodItems: "Produkter",
    printSelected: "Skriv ut valgte",
    mandatoryField: "angir et obligatorisk felt",
    categoryName: "Kategorinavn*",
    description: "Beskrivelse",
    descriptionHint: "Linjeskift med Enter",
    standardCategory: "Standardkategori",
    fieldRequired: "Feltet er påkrevd",
    standard: "Standard",
    devices: "Enheter",
    deviceNick: "Enhetens kallenavn",
    deviceID: "Enhets-ID",
    confirmDeleteDevice: "Er du sikker på at du vil slette enheten:",
    userAdministration: "Brukeradministrasjon",
    newPasswordOptional: "Nytt passord (valgfritt)",
    passwordFormat: "Passord*",
    password: "Passord",
    admin: "Administrator",
    printFooditems: "Skriv ut etiketter",
    fromFooditems: "fra matvarer",
    loadingHomepage: "Laster hjemmeside...",
    pleaseLogin: "Logg inn for å få tilgang til hjemmesiden",
    settings: "Innstillinger",
    displaySettings: "Visningsinnstillinger",
    theme: "Tema",
    light: "Lyst",
    dark: "Mørkt",
    language: "Språk",  
    selectLanguage: "Velg språk",
    finnish: "Finsk",
    danish: "Dansk",
    english: "Engelsk",
    swedish: "Svensk",
    norweigian: "Norsk",
    german: "Tysk",
    japaneese: "Japansk",
    selectedLabel: "Valgt etikett",
    dataManagement: "Databehandling",
    importData: "Importer data",
    exportData: "Eksporter data",
    importExport: "Import / Eksport",
    exportProducts: "Eksporter produkter",
    importProducts: "Importer produkter",
    selectFile: "Velg fil",
    upload: "Last opp",
    download: "Last ned",
    dataImportSuccess: "Data ble importert",
    dataImportError: "Feil ved import av data",
    importProductsSubtitle: "Importer produkter fra en xlsx-fil.",
    useCategories: "Vis kategorier",
    defaultLabel: "Standardetikett",
    defaultLabelHint: "Velg etiketten som er forhåndsvalgt ved utskrift.",
    noLabelsAvailable: "Ingen etiketter tilgjengelige",
    copy: "Kopi",
    useAliasAsTitle: "Bruk alias som tittel",
    useAliasAsTitleHint: "Bruk feltet 'Alias' i stedet for 'Produktnavn'. Hvis 'Alias' er tomt, brukes 'Produktnavn'.",
    menus: "Menyer",
    locations: "Lokasjoner",
    deleteSelected: "Slett valgte",
    confirmDeleteSelected: "Er du sikker på at du vil slette {count} produkter?",
    create: "Opprett",
    createNewCategory: "Opprett ny kategori",
    nutritionProfile: "Næringsprofil",
    nutritionProfileHint: "Brukes av næringselementet på etiketter.",
    noNutritionProfiles: "Ingen næringsprofiler ennå",
    days: "Dager",
    hours: "Timer",
    alias: "Alias",
    barcode: "Strekkode",

    // Label Designer
    labelDesigner: "Etikettdesigner",
    saveLabel: "Lagre etikett",
    refresh: "Oppdater",
    selectLabel: "Velg etikett",
    createNewLabel: "Opprett ny etikett",
    labelName: "Etikettnavn",
    width: "Bredde (mm)",
    height: "Høyde (mm)",
    titleFont: "Tittelskrift (pt)",
    titleX: "Tittel X (mm)",
    titleY: "Tittel Y (mm)",
    active: "Aktiv",
    addField: "Legg til felt",
    fieldType: "Felttype",
    labelText: "Felttekst",
    baseDate: "Basisdato",
    offsetField: "Offsetfelt",
    databaseField: "Databasefelt",
    xPosition: "X-posisjon (mm)",
    yPosition: "Y-posisjon (mm)",
    fontSize: "Skriftstørrelse (pt)",
    qrSize: "QR-kodens størrelse (mm)",
    preview: "Forhåndsvisning",
    sampleItemName: "Eksempel på produktnavn",
    size: "Størrelse",
    scale: "Skala",
    fieldsCount: "Felter",
    newLabel: "Ny etikett",
    newField: "Nytt felt",
    labelSaved: "Etiketten er lagret!",
    loadLabelsFailed: "Kunne ikke laste etiketter",
    saveLabelFailed: "Kunne ikke lagre etiketten",
    labelPrinting: "Etikettutskrift",
    productsPerPage: "Elementer per side",
    showAll: "Vis alle",
    selectAtLeastOne: "Velg minst ett element.",
    noLabelSelected: "Ingen etikett valgt. Velg en i innstillingene.",
    labelColor: "Etikettfarge",
    creditZplImage: "ZPL-bildeplugin utviklet av: ",
    fieldTypePrompt: "Inndataspørsmål",
    promptDialogTitle: "Inndata",

    // Label Type
    labelType: "Etikettype",
    labelTypeStandard: "Standard",
    labelTypeFreetext: "Fritekst",
    freetextNotice: "Fritekstetiketter er tomme felt for fri tekstinntasting på nettbrettet. Verken produktnavn eller forhåndsdefinerte felt vises.",

    // Logo
    logo: "Logo",
    logoReplace: "Erstatt",
    logoUpload: "Last opp",
    logoRemove: "Fjern",
    logoNoLogo: "Ingen logo lastet opp. Legg til en for å plassere den på etiketten.",
    logoUploadTitle: "Last opp logo",
    logoSelectFile: "Velg PNG-bilde",
    logoSelectFileHint: "Last opp bildet allerede rotert, slik du vil ha det skrevet ut.",
    logoWidthOnLabel: "Bredde på etikett (mm)",
    logoWidthHint: "Høyden beregnes automatisk",
    logoPrinterDpi: "Skriverens DPI",
    logoOriginal: "Original",
    logoTarget: "Mål",
    logoBlackThreshold: "Svartterskel",
    logoBlackThresholdHint: "Lavere = bare mørke piksler blir svarte. Høyere = også lysere piksler blir svarte.",
    logoPreviewOriginal: "Original",
    logoPreviewMono: "Monokrom (som utskrevet)",
    logoApply: "Bruk",
    logoLoaded: "Logo lastet ({width}×{height}mm). Bruk X/Y nedenfor for å plassere den på etiketten.",
    logoNotUploaded: "Ingen logo lastet opp ennå. Gå til Etikettinnstillinger → Logo for å laste opp en.",
    logoUploaded: "Logoen er lastet opp og konvertert",
    logoUploadFailed: "Kunne ikke laste opp logoen",
    logoProcessFailed: "Kunne ikke behandle logoen",
    logoInvalidDimensions: "Ugyldige mål",
    logoNoFile: "Ingen fil valgt",

    // Field Types (dropdown titles)
    fieldTypeDate: "Dato",
    fieldTypeDatePlus: "Dato + dager",
    fieldTypeDatabase: "Databasefelt",
    fieldTypeQrcode: "QR-kode",
    fieldTypeBarcode: "Strekkode (Code128)",
    fieldTypeLogo: "Logobilde",
    fieldTypeValueOnly: "Bare verdi (flytende)",
    fieldTypeAllergensText: "Allergentekst",
    fieldTypeStatic: "Statisk tekst",
    fieldTypeDivider: "Skillelinje",

    // Value Only sub-types
    valueType: "Verditype",
    valueTypeDate: "Dato",
    valueTypeDatePlus: "Dato + dager",
    valueTypeDatabase: "Databasefelt",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Rotasjon",

    // Separator & value position
    separator: "Skilletegn",
    separatorHint: "Tekst mellom ledetekst og verdi. La stå tom for ingen skilletegn.",
    separatorPlaceholder: ": ",
    valueXMm: "Verdi X (mm)",
    valueXHint: "La stå tom for å plassere etter ledeteksten",
    valueYMm: "Verdi Y (mm)",
    valueYHint: "La stå tom for å bruke ledetekstens Y",
    valueFontSize: "Verdiens skriftstørrelse",
    valueFontSizeHint: "La stå tom for å bruke ledetekstens størrelse",

    // Font style
    bold: "Fet",
    italic: "Kursiv",

    // Text alignment
    textAlignment: "Tekstjustering",
    alignLeft: "Venstre",
    alignCenter: "Sentrert",
    alignRight: "Høyre",

    // QR Code
    qrDataSource: "QR-datakilde",

    // Barcode
    barcodeDataSource: "Datakilde",
    barcodeWidthMm: "Strekkodens bredde (mm)",
    barcodeHeightMm: "Strekkodens høyde (mm)",
    barcodeDisplayValue: "Vis verdien under strekkoden",

    // Allergens text
    allergenSeparator: "Skilletegn",
    allergenSeparatorHint: "Tegn mellom allergennavn (f.eks. ', ' eller ' / ')",

    // Divider
    dividerLineWidth: "Linjebredde (mm)",
    dividerLineWidthHint: "Skillelinjens bredde",
    dividerLineThickness: "Linjetykkelse (mm)",
    dividerLineThicknessHint: "Linjens tykkelse",

    // Date Base
    
    // Database Fields
    fridgeValue: "Kjøleskapsverdi",
    fridgeValueHint: "f.eks. FØR ÅPNING",
    threeHours: "Tre timer (JA/NEI)",
    itemName: "Produktnavn",
    
    // Offset Fields
    thawingDaysOffset: "Tiningsdager",
    refrigeratedDaysOffset: "Kjøledager",
    expiryDays: "Holdbarhet (dager)",
    thawingHours: "Tiningstimer",
    refrigeratedHours: "Kjøletimer",
    expiryHours: "Holdbarhet (timer)",
    showTime: "Vis klokkeslett",
    
    // QR Data Fields
    itemId: "Produkt-ID",
    customUrl: "Egendefinert URL",
    customData: "Egendefinerte data",

    // Snackbar / status messages
    labelSavedSuccess: "Etiketten er lagret",
    labelSaveFailed: "Kunne ikke lagre etiketten",
    labelLoadFailed: "Kunne ikke laste etiketter",
    labelLoadSingleFailed: "Kunne ikke laste etiketten",
    fieldOrderUpdated: "Feltrekkefølgen er oppdatert",

    // Labels management view
    labelsDescription: "Administrer etikettene dine — se detaljer, aktiver/deaktiver eller slett.",
    totalLabels: "Etiketter totalt",
    activeLabels: "Aktive etiketter",
    inactiveLabels: "Inaktive etiketter",
    labelsList: "Etiketter",
    searchLabels: "Søk i etiketter...",
    dimensions: "Mål",
    inactive: "Inaktiv",
    color: "Farge",
    type: "Type",
    freetext: "Fritekst",
    viewLabel: "Vis etikett",
    noLabelsFound: "Ingen etiketter funnet",
    createFirstLabel: "Opprett din første etikett",
    namePosition: "Navnets posisjon",
    fieldLabel: "Feltnavn",
    position: "Posisjon",
    noFields: "Ingen felt konfigurert",
    hasLogo: "Logo lagt til",
    status: "Status",
    editInDesigner: "Rediger i designeren",
    confirmDeleteText: "Er du sikker på at du vil slette '{labelName}'? Handlingen kan ikke angres.",
    deleteWarning: "Alle felt som hører til etiketten blir også slettet.",
    labelActivated: "'{name}' er nå aktiv",
    labelDeactivated: "'{name}' er nå inaktiv",
    labelToggleError: "Kunne ikke endre etikettens status",
    labelDeleted: "'{name}' er slettet",
    labelDeleteError: "Kunne ikke slette etiketten",
    close: "Lukk",
    deleteLabel: "Slett etikett",

    // device management
    devicesDescription: "Administrer enhetene og lisensene dine.",
    totalLicenses: "Lisenser totalt",
    usedLicenses: "Brukte lisenser",
    availableLicenses: "Ledige lisenser",
    devicesList: "Enheter",
    searchDevices: "Søk i enheter...",
    deleteDevice: "Slett enhet",
    noDevicesFound: "Ingen enheter funnet",
    noDevicesHint: "Enheter registreres via appen.",
    deleteDeviceHint: "Enheten må registreres på nytt før den kan brukes.",
    deviceDeleted: "'{name}' er slettet",
    deviceDeleteError: "Kunne ikke slette enheten",
    canEdit: "Kan redigere",
    cannotEdit: "Kan ikke redigere",
    canEditProducts: "Redigering",
    allowEditing: "Tillat redigering",
    disableEditing: "Deaktiver redigering",
    editingEnabled: "Redigering aktivert",
    editingDisabled: "Redigering deaktivert",
    selected: "valgt",
    updateError: "Oppdateringen mislyktes",
    canDelete: "Kan slette",
    cannotDelete: "Kan ikke slette",
    canDeleteProducts: "Sletting",
    allowDeleting: "Tillat sletting",
    disableDeleting: "Deaktiver sletting",
    deletingEnabled: "Sletting aktivert",
    deletingDisabled: "Sletting deaktivert",
    editingDisabledCascade: "Redigering deaktivert — sletting ble også deaktivert",
    deletingEnabledCascade: "Sletting aktivert — redigering ble også aktivert",
    allowBackdating: "Tillat tilbakedatering",
    disallowBackdating: "Deaktiver tilbakedatering",
    backdatingEnabled: "Tilbakedatering aktivert",
    backdatingDisabled: "Tilbakedatering deaktivert",
    backdatingDisabledCascade: "Tilbakedatering deaktivert — redigering ble også deaktivert",
    backdatingEnabledCascade: "Tilbakedatering aktivert — redigering ble også aktivert",
    backdatingOff: "Tilbakedatering deaktivert",
    backdatingOn: "Tilbakedatering aktivert",
    maxBackdateDays: "Maksimalt antall dager for tilbakedatering",
    maxBackdateDaysHint: "Angi hvor mange dager tilbake en bruker kan velge for produksjons-/åpningsdato. 0 deaktiverer tilbakedatering.",

    // Configurations Page
    configurations: "Konfigurasjoner",
    globalSettings: "Globale innstillinger",
    globalSettingsHint: "Disse innstillingene gjelder alle nettbrett på kontoen. Lagring øker versjonen slik at nettbrettene henter de nye innstillingene.",
    tabletFields: "Nettbrettfelt",
    tabletFieldConfig: "Konfigurasjon av nettbrettfelt",
    tabletFieldConfigHint: "Konfigurer hvilke felt som vises når elementer opprettes eller redigeres på nettbrett.",
    tabletFieldConfigInfo: "Dra for å endre rekkefølge. Skjulte felt vises ikke i nettbrettdialogene. Påkrevde felt må fylles ut før lagring.",
    freetextLabels: "Fritekstetiketter",
    freetextLabelsOverview: "Fritekstetiketter",
    freetextLabelsHint: "Alle fritekstetiketter inkludert lokale nettbrettetiketter. Lokale etiketter vises bare på enheten som opprettet dem.",
    noFreetextLabels: "Ingen fritekstetiketter funnet.",
    reassignToDevice: "Tildel til enhet",
    reassignHint: "Velg en enhet å tildele denne fritekstetiketten til. Den vil ikke lenger vises på den opprinnelige enheten.",
    labelsSelected: "{count} etikett(er) valgt",
    targetDevice: "Målenhet",
    markAsLocal: "Merk som lokal",
    reassign: "Tildel",
    moveToDevice: "Flytt til enhet",
    removeFromAll: "Fjern fra alle enheter",
    broadcastNewLabel: "Send en ny etikett til flere enheter",
    broadcastNew: "Opprett ny",
    broadcast: "Publiser",
    freetextContent: "Fritekstinnhold",
    selectAll: "Velg alle",
    deselectAll: "Fjern alle valg",
    selectDevices: "Velg enheter",
    broadcastDevices: "Send til {count}",
    devicesSelected: "{count} enhet(er) valgt",
    pushToDevices: "Send til {count} enheter",
    pushExistingHint: "Send en eksisterende etikett til flere enheter.",
    activeBroadcasts: "Aktive kringsendinger",
    broadcastsHint: "Fritekstetiketter som for øyeblikket er sendt til flere enheter. De forblir aktive til de fjernes manuelt fra alle enheter eller tildeles én enkelt enhet.",
    noBroadcasts: "Ingen aktive kringsendinger",
    valuesInDays: "dager",
    valuesInHours: "timer",
    showAlias: "Vis alias",
    showAliasHint: "Vis feltet 'Alias' på nettbrettets startskjerm under produktnavnet.",
    showMenuTab: "Vis menyfane",
    showMenuTabHint: "Vis den aktive menyen som en fane på nettbrettets startskjerm",
    hideCategoryAll: "Skjul kategorien 'Alle'",
    hideCategoryAllHint: "Skjul kategorien 'Alle' fra kategorimenyen på nettbrett",

    // Global Settings Toggles
    useCategoriesHint: "Vis kategorimenyen på nettbrett og kategorivalg når elementer opprettes",
    usePrintDialog: "Vis utskriftsdialog",
    usePrintDialogHint: "Vis en dialog med datovalg før etiketter skrives ut på nettbrett",
    showTimestampOnDates: "Vis klokkeslett på datoer",
    showTimestampOnDatesHint: "Inkluder tidsstempel TT:MM på datoetiketter (f.eks. 17/02/26 10:30)",
    showCategoryOnProduct: "Vis kategori på produkt",
    showCategoryOnProductHint: "Vis kategorinavnet under produktnavnet på nettbrettets startskjerm",
    todaysDateInclusive: "Dagens dato inkludert",
    todaysDateInclusiveHint: "Regn med dagens dato i utløpsberegningen (f.eks. 3 dager fra mandag = onsdag i stedet for torsdag)",
    settingsVersionInfo: "Gjeldende versjon",
    settingsVersionHint: "Nettbrett med en eldre versjon henter de oppdaterte innstillingene ved neste oppdatering.",
    saveChanges: "Lagre endringer",

    // Field Config Table
    fieldName: "Felt",
    customLabel: "Egendefinert ledetekst",
    visible: "Synlig",
    required: "Påkrevd",

    // Freetext Table
    content: "Innhold",
    device: "Enhet",
    scope: "Omfang",
    updated: "Oppdatert",
    local: "Lokal",
    global: "Global",
    confirmDeleteFreetext: "Er du sikker på at du vil slette denne fritekstetiketten?",
    freetextSizes: "Tilgjengelige størrelser",
    freetextSizesHint: "Liste over tilgjengelige fritekststørrelser.",
    createSize: "Opprett størrelse",
    createFreetextSize: "Opprett fritekststørrelse",
    widthMm: "Bredde (mm)",
    heightMm: "Høyde (mm)",
    freetextSizeWhiteHint: "Fritekstetiketter vises som hvite",
    default: "Standard",
    setAsDefault: "Angi som standard",
    cancelDefault: "Fjern standard",

    // Location management
    locationName: "Lokasjonsnavn",
    assignUser: "Tildel bruker",
    assignedUsers: "Tildelte brukere",
    noUsersAssigned: "Ingen brukere tildelt",
    addUsers: "Legg til brukere",
    selectUsers: "Velg brukere",
    assignProducts: "Tildel produkter",
    assignedProducts: "Tildelte produkter",
    availableProducts: "Tilgjengelige produkter",
    noProductsAssigned: "Ingen produkter tildelt",
    allProductsAssigned: "Alle produkter tildelt",
    countryCode: "Landskode",
    timezone: "Tidssone",
    createdLocation: "Lokasjonen er opprettet",
    editLocation: "Rediger lokasjon",
    totalLabelsPrinted: "Totalt antall etiketter skrevet ut",
    clickForBreakdown: "Klikk for en detaljert oversikt",
    printStatsTitle: "Utskriftsstatistikk",
    noPrintEvents: "Ingen utskriftsstatistikk funnet for lokasjoner",
    labelsPrintedTotal: "etiketter skrevet ut totalt",
    since: "siden",
    createLocation: "Opprett lokasjon",

    //Tickets System
    createTicket: "Opprett sak",
    ticketType: "Sakstype",
    ticketTypeSale: "Salg",
    ticketTypeSupport: "Support",
    ticketTypeBug: "Feilrapport",
    ticketTitle: "Tittel",
    ticketDescriptionHint: "Beskriv problemet eller forespørselen i detalj",
    ticketReporter: "Rapportør",
    ticketCreated: "Saken er opprettet",
    priority: "Prioritet",
    priorityHint: "La stå tomt og la systemet avgjøre ut fra sakens innhold, eller velg manuelt",
    priorityAuto: "Auto",
    priorityLow: "Lav",
    priorityMedium: "Middels",
    priorityHigh: "Høy",
    priorityUrgent: "Haster",
    submit: "Send sak",
    tickets: "Saker",
    orderAccessories: "Bestill etiketter og tilbehør",
    ticketLogHint: "Liste over supporthenvendelser sendt til Capture IT.",

    impersonation: {
        menuItem: "Gå inn som kunde",
        title: "Gå inn som kunde",
        subtitle: "Velg en kunde for å arbeide i kontoen deres. Alt du gjør skjer med deres virkelige data.",
        search: "Søk etter kunde, kontonummer eller e-post...",
        customer: "Kunde",
        lastPrint: "Sist skrevet ut",
        enter: "Gå inn",
        noCustomers: "Ingen kunder funnet",
        loadFailed: "Kunne ikke hente kundelisten",
        confirmTitle: "Gå inn i kundens konto?",
        confirmText: "Du er i ferd med å åpne kontoen til {customer} med rettighetene til deres egen administrator.",
        confirmWarning: "Alt du gjør skjer med kundens virkelige data. Økten logges og utløper automatisk etter 2 timer.",
        bannerTitle: "Du arbeider i kontoen til {customer}",
        bannerSubtitle: "Innlogget som deg selv ({user}) bak",
        stop: "Avslutt",
        actions: "Handlinger"
    },

    designer: {
        untitled: "Uten tittel",
        noLabel: "Ingen etikett valgt",
        saved: "Lagret",
        saveError: "Kunne ikke lagre",
        unsavedTitle: "Ulagrede endringer",
        unsavedConfirm: "Du har ulagrede endringer. Vil du forlate siden?",
        leaveAnyway: "Forlat likevel",
        stay: "Bli værende",
        toggleGrid: "Slå rutenett av/på",
        preview: "Forhåndsvisning",
        undo: "Angre",
        redo: "Gjør om",
        save: "Lagre",
        print: "Skriv ut",
        back: "Tilbake",
    },
    fields: {
        productFields: "Produktfelt",
        productField: "Produktfelt",
        barcodes: "Strekkoder",
        layout: "Layout",
        qrCode: "QR-kode",
        staticText: "Statisk tekst",
        imageLogo: "Logobilde",
        divider: "Skillelinje",
        productNumber: "Produktnummer",
        productName: "Produktnavn",
        description: "Beskrivelse",
        costPrice: "Kostpris",
        salesPrice: "Salgspris",
        currency: "Valuta",
    },
    common: {
        none: "Ingen",
        save: "Lagre",
        cancel: "Avbryt",
        delete: "Slett",
        close: "Lukk",
        edit: "Rediger",
        copy: "Kopier",
        unsaved: "Ulagrede endringer",
        loading: "Laster...",
        error: "Feil",
        success: "Vellykket",
    },
    label: {
        name: "Etikettnavn",
        width: "Bredde (mm)",
        height: "Høyde (mm)",
        color: "Farge",
        colour: "Farge",
        type: "Type",
        grid: "Rutenett",
        gridSize: "Rutenettstørrelse (mm)",
        active: "Aktiv",
        unit: "Enhet",
        mm: "mm",
        inch: "tomme",
    },
    canvas: {
        grid: "Vis rutenett",
        gridSize: "Rutenettstørrelse (mm)",
        layers: "Lag",
        noElements: "Ingen elementer",
    },
    importFromOld: "Importer fra det gamle systemet",
    selectLabelsToImport: "Velg etiketter som skal importeres",
    importHint: "Etikettene importeres til det nye systemet. Originalen beholdes.",
    importCount: "Importer {n} etikett(er)",
    newDesign: "Ny etikett",
    designs: "Etiketter",
    searchDesigns: "Søk i etiketter...",
    totalDesigns: "Etiketter totalt",
    activeDesigns: "Aktive etiketter",
    inactiveDesigns: "Inaktive etiketter",
    designCreated: "Etiketten er opprettet",
    designCopied: "Etiketten er kopiert",
    designDeleted: "Etiketten er slettet",
    designsDeleted: "Etikettene er slettet",
    deleteDesign: "Slett etikett",
    deleteDesignConfirm: "Er du sikker på at du vil slette '{name}'?",
    bulkDelete: "Slett valgte",
    bulkDeleteConfirm: "Er du sikker på at du vil slette {n} etiketter?",
    errorCreating: "Kunne ikke opprette etiketten",
    errorUpdating: "Kunne ikke oppdatere etiketten",
    errorCopying: "Kunne ikke kopiere etiketten",
    errorDeleting: "Kunne ikke slette etiketten",
    errorLoading: "Kunne ikke laste etiketter",
    importSuccess: "{n} etikett(er) importert",
    importError: "Feil ved import",
    labelsSubtitle: "Administrer etikettene dine",
    roundExpiryDownToQuarter: "Rund utløpstiden ned til nærmeste kvarter",
    roundExpiryDownToQuarterHint: "Bare når holdbarheten er i timer. Et utløp kl. 16:07 vises som 16:00 — alltid ned, slik at holdbarheten aldri overskrides",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "Etiketten \"{label}\" er inaktiv — skriver ut med \"{fallback}\"",
    labelMissingFallback: "Ingen etikett valgt — skriver ut med \"{fallback}\"",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Slett de valgte kategoriene?",
    bulkDeleteWarning: "Handlingen kan ikke angres.",
    categoriesInUseTitle: "Kategoriene er i bruk",
    categoriesInUseText: "Følgende kategorier inneholder fortsatt varer:",
    moveProductsTo: "Flytt varene til",
    moveAndDelete: "Flytt og slett",
    noReassignTarget: "Alle kategorier er valgt. Fjern minst én for å flytte varene dit.",
    categoriesDeleted: "kategorier slettet",
    productsMoved: "varer flyttet",
    defaultCategorySkipped: "standardkategorien ble hoppet over",
    bulkDeleteFailed: "Slettingen mislyktes",

    totalLocations: "Lokasjoner totalt",

    productImage: "Produktbilde",
    chooseFromLibrary: "Velg fra bibliotek",
    changeImage: "Bytt bilde",
    productImageHint: "Vises på nettbrettet i stedet for produktnavnet, hvis bildevisning er slått på",
    productImageLibrary: "Bildebibliotek",

    productImages: {
        libraryTitle: "Bildebibliotek",
        libraryHint: "Last opp alle produktbildene på én gang og velg dem inn på varene etterpå.",
        uploadButton: "Last opp bilder",
        deleteSelected: "Slett valgte",
        uploadProgress: "Laster opp",
        alreadyInLibrary: "Finnes allerede i biblioteket",
        noImages: "Ingen bilder ennå",
        preview: "Forhåndsvisning",
        name: "Navn",
        dimensions: "Mål",
        usedBy: "Brukes av",
        uploaded: "Lastet opp",
        uploadSummary: "{n} bilder lastet opp",
        uploadSummaryFailed: "{n} lastet opp, {failed} mislyktes",
        uploadSummaryDuplicates: "{n} lastet opp, {duplicates} hoppet over som duplikater",
        imageRenamed: "Bildet har fått nytt navn",
        renameFailed: "Kunne ikke gi bildet nytt navn",
        confirmDeleteImage: "Er du sikker på at du vil slette dette bildet?",
        deleteImageInUseWarning: "{n} varer bruker dette bildet og mister det.",
        imageDeleted: "Bildet er slettet",
        imageDeletedInUse: "Bildet er slettet — varene som brukte det, har nå ingen bilde",
        deleteFailed: "Kunne ikke slette bildet",
        confirmBulkDelete: "Bekreft sletting",
        confirmBulkDeleteText: "Er du sikker på at du vil slette {n} bilder?",
        selectedInUseWarning: "{n} av de valgte bildene er i bruk og forsvinner fra varene som bruker dem.",
        andMoreCount: "… og {n} til",
        deleteAll: "Slett alle",
        imagesDeletedSummary: "{n} bilder slettet",
        imagesDeletedMissing: "{n} bilder slettet ({missing} ble ikke funnet)",
        bulkDeleteFailed: "Kunne ikke slette bildene",

        picker: {
            title: "Velg bilde",
            uploadNew: "Last opp nye",
            search: "Søk i bilder...",
            empty: "Det er ingen bilder i biblioteket ennå. Last opp noen for å komme i gang.",
            noMatch: "Ingen bilder samsvarer med søket",
            removeImage: "Fjern bilde",
            uploadFailedCount: "{n} bilder kunne ikke lastes opp",
        },
    },
    showProductImages: "Vis produktbilder",
    showProductImagesHint: "Vis produktbilder på nettbrettets startskjerm.",
    showProductNames: "Vis produktnavn",
    showProductNamesHint: "Vis produktnavn på nettbrettets startskjerm.",

    productDisplayMode: "Produktvisning",
    displayModeText: "Navn",
    displayModeImage: "Bilder",
    displayModeUser: "Brukerens valg",
    mixed: "Blandet",
    noDevicesUpdated: "Ingen enheter ble oppdatert",
    customFields: "Egendefinerte felt",
    customFieldsHint: "Legg til felt for å vise spesifikk produktinformasjon",
    noCustomFields: "Ingen egendefinerte felt",
    editField: "Rediger felt",
    fieldLabelHint: "Ledetekst for feltet",
    fieldPrefixHint: "Prefiks for feltet",
    fieldKeyFixedHint: "Nøkkel for feltet (kan ikke endres)",
    deleteFields: "Slett felt",
    deleteFieldsWarning: "Dette sletter de valgte feltene permanent",
    deactivateInsteadHint: "Deaktiver i stedet for å slette",
    fieldsDeleted: "Feltene er slettet",
    valuesRemoved: "Verdiene er fjernet",
    storedValues: "Lagrede verdier",
    printedPrefix: "Utskrevet prefiks",
    prefix: "Prefiks",
    fieldKey: "Feltnøkkel",
    values: "Verdier",
    sortOrder: "Sorteringsrekkefølge",
    labelRequired: "Ledetekst er påkrevd",

    ...designerI18n.no,
}